import { Component, OnInit, Inject} from "@angular/core";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {}

  clicLink(link){
    this.document.location.href = link;
  }
}
